import { parseQueryMethodArguments } from './parse-query-method-arguments.js';

function parseArrayEntry(...args) {
  const {
    query,
    key,
    value
  } = parseQueryMethodArguments(...args);

  // Remove falsey query params that might cause unneccessary operational load
  if (typeof value === 'string' && value.includes(',')) {
    query[key] = value.split(',');
  }
  return query;
}

export { parseArrayEntry };
